import { containerStyle } from '../../../SignUp/styles';

export default {
  container: {
    ...containerStyle,
    textAlign: 'center'
  },
  goBack: {
    marginTop: 15,
    textDecoration: 'none'
  }
};
